/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSection } from '@fitinsur/components'

import { LossPayeeSection } from '../index';
import { GeneralSection } from '../../general/index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  lossPayeeGroup,
  setLossPayeeGroup,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {

  return (
    <>
      {lossPayeeGroup.map((questions, index) => (
        <FormSection
          key={index}
          sectionIndex={index}
          sectionName="LOSS_PAYEE"
          formikRef={formikRef}
          disableAll={disableAll}
          values={formikProps.values}
          errors={formikProps.errors}
          setFieldValue={formikProps.setFieldValue}
          setFieldError={formikProps.setFieldError}
          questionnaire={questions}
          idOperation={idOperation}
          idOperationParent={idOperationParent}
          idProduct={idProduct}
          ignoreModality
          extraButtons={() => GeneralSection.components.RenderSectionAddAndRemoveRowButtons({
            partySectionName: "LOSS_PAYEE",
            sectionState: lossPayeeGroup,
            setSectionState: setLossPayeeGroup,
            index,
            questions,
            questionnaireAnswersToDelete,
            setQuestionnaireAnswersToDelete,
          })}
          onQuestionChange={(
            question,
            value,
            questionnaireUpdated,
            setQuestionnaireUpdated,
            setFieldValue
          ) =>
            LossPayeeSection.events.handleQuestionChange({
              question,
              value,
              questionnaireUpdated,
              setQuestionnaireUpdated,
              setFieldValue,
              globalQuestionnaire,
            })
          }
        />
      ))}
    </>
  )
}

const components = {
  RenderSection
}

export { components }